import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ODOO_STANDARD_ANNUAL, ODOO_STANDARD_QUARTERLY } from './odoo-plans.consts';

@Component({
  selector: 'app-subscription-plans',
  templateUrl: './subscription-plans.component.html',
  styleUrls: ['./subscription-plans.component.scss'],
  imports: [TranslateModule],
})
export class SubscriptionPlansComponent {
  readonly isProduction = environment.production;
  readonly resubscription = input<boolean>(false);
  readonly disableButtons = input<boolean>(false);
  readonly reference = input<any>();

  constructor() {}

  subscribeYearly() {
    this.reference().yearlyPayment();
  }

  subscribeMonthly() {
    this.reference().monthlyPayment();
  }

  subscribeQuarterly() {
    this.reference().quarterlyPayment();
  }

  // Odoo checkout, dev/sandbox only — one entry point per plan shown on this page
  subscribeQuarterlyUsingOdoo() {
    this.reference().subscribeUsingOdoo(ODOO_STANDARD_QUARTERLY.productId, ODOO_STANDARD_QUARTERLY.planId);
  }

  subscribeAnnuallyUsingOdoo() {
    this.reference().subscribeUsingOdoo(ODOO_STANDARD_ANNUAL.productId, ODOO_STANDARD_ANNUAL.planId);
  }
}
